export const enClientPortalValuationTenantListPage = {
    rowsLabel_one: '{{count}} row',
    rowsLabel_other: '{{count}} rows',
    viewSwitch: {
        summary: 'Summary',
        tenantDetails: 'Tenant details',
    },
    tenantDetailsTable: {
        discrepancyTooltip: {
            title: 'Summary discrepancy',
            description: 'The sum of the tenant details does not match the value in the summary. Please review it.',
            details: 'Tenant details',
            summary: 'Summary',
            discrepancy: 'Discrepancy',
        },
        discrepancyTooltipTitle: 'Columns with discrepancies:',
        discrepancyHeaders: {
            units: 'Units',
            area: 'Area',
            contractRentPerYear: 'Contract rent per year',
            marketRentPerYear: 'Market rent per year',
        },
        headers: {
            id: 'ID',
            floor: 'Floor',
            tenant: 'Tenant',
            subUsageType: 'Sub-usage type',
            leaseId: 'Lease ID',
            status: 'Status',
            area: 'Area',
            units: 'Units',
            startDate: 'Start date',
            endDate: 'End date',
            remainingLeaseTerm: 'Remaining term',
            contractRentPerMonth: 'Contract rent per month',
            contractRentPerYear: 'Contract rent per year',
            marketRentPerMonth: 'Market rent per month',
            marketRentPerYear: 'Market rent per year',
            absoluteDelta: 'Delta absolute',
            deltaPercentage: 'Delta %',
            comments: 'Comments',
        },
        labels: {
            area: 'Area',
            vacancyArea: 'Vacant area',
            units: 'Units',
            vacancyUnits: 'Vacancy units',
            indefinite: 'open-ended',
            years: 'years',
        },
        unitLabels: {
            regular: 'unit',
            parking: 'park. sp.',
            perYear: '/year',
            perSquareMeter: '/m²',
            perUnit: '/unit',
            perParkingSpace: '/park. sp.',
        },
    },
    summary: {
        marketRentPerYear: 'Market rent per year',
        delta: 'Delta',
        contractRentPerYear: 'Contract rent per year',
        rented: 'Rented',
        vacant: 'Vacant',
        totalUsableArea: 'Total usable area',
        parkingSpaces: '{{count}} park. sp.',
        totalParkingSpaces: 'Total parking spaces',
    },
}
